package components.finishingUp

import components.project.isProjectEditable
import it.neckar.commons.kotlin.js.safeGet
import it.neckar.lizergy.model.configuration.quote.QuoteConfiguration
import it.neckar.lizergy.model.configuration.quote.builder.previousInverterStringCount
import it.neckar.lizergy.model.project.ResolvedProject
import it.neckar.lizergy.model.stumps.requireUniqueInverterConfigurationIds
import it.neckar.open.collections.fastForEachIndexed
import it.neckar.react.common.*
import it.neckar.react.common.button.*
import react.*
import react.dom.*
import services.UiActions
import store.hooks.useLoadProcessStates

val MessdatenOverview: FC<MessdatenOverviewProps> = fc("MessdatenOverview") { props ->
  val processStatesResolver = useLoadProcessStates()

  val project = props::project.safeGet()
  val currentConfiguration = props::currentConfiguration.safeGet()

  val assemblyRoof = project.assemblyRoof
  val assemblyBasement = project.assemblyBasement
  val editableStatus = project.isProjectEditable()

  val assemblyRoofInverterMessdatenState = useState(assemblyRoof.inverterMessdaten)
  val assemblyBasementInverterMessdatenState = useState(assemblyBasement.inverterMessdaten)
  val (downloadStringPlanBusy, setDownloadStringPlanBusy) = useState(false)


  useEffect(assemblyRoofInverterMessdatenState.value) {
    val assemblyRoofToSave = assemblyRoof.copy(inverterMessdaten = assemblyRoofInverterMessdatenState.value)
    UiActions.saveAssemblyRoof(assemblyRoofToSave)
  }

  useEffect(assemblyBasementInverterMessdatenState.value) {
    val assemblyBasementToSave = assemblyBasement.copy(inverterMessdaten = assemblyBasementInverterMessdatenState.value)
    UiActions.saveAssemblyBasement(assemblyBasementToSave)
  }


  div("my-4") {
    div("my-3") {
      actionButton(
        icon = ButtonIconCentered(if (downloadStringPlanBusy) "spinner-border spinner-border-sm" else FontAwesomeIcons.Download),
        classes = "btn btn-primary ${if (currentConfiguration == null) "disabled" else ""}",
        action = {
          check(currentConfiguration != null) { "Configuration must not be null to create AssemblyPortfolio" }
          setDownloadStringPlanBusy(true)
          try {
            //Download the newly created quote offer snapshot
            UiActions.downloadStringPlanPdf(project.projectId, currentConfiguration.configurationId)
          } finally {
            setDownloadStringPlanBusy(false)
          }
        }) {
        b("ms-2") {
          +"Stringplan herunterladen"
        }
      }
    }

    h4("my-3") { +"Messdaten" }

    busyIfNull(processStatesResolver) {
      val currentConfiguration = project.getCurrentQuoteConfiguration(it)
      val inverterConfigurations = currentConfiguration?.facilityConfiguration?.inverterConfigurations

      console.log("Rendering MessdatenOverview - inverterConfigurations: ${inverterConfigurations?.size}")

      inverterConfigurations?.requireUniqueInverterConfigurationIds()
      inverterConfigurations?.fastForEachIndexed { inverterConfigurationIndex, inverterConfiguration ->
        val previousInverterStringCount = inverterConfigurations.previousInverterStringCount(inverterConfigurationIndex)

        console.log("inverter index: $inverterConfigurationIndex - previousInverterStringCount: $previousInverterStringCount")

        div("mb-3") {
          key = inverterConfiguration.id.format()

          EditInverterMessdaten {
            attrs {
              this.assemblyRoofInverterMessdatenState = assemblyRoofInverterMessdatenState
              this.assemblyBasementInverterMessdatenState = assemblyBasementInverterMessdatenState
              this.inverterConfigurationIndex = inverterConfigurationIndex
              this.inverterConfiguration = inverterConfiguration
              this.moduleLayouts = currentConfiguration.moduleLayouts
              this.previousInverterStringCount = previousInverterStringCount
              this.editableStatus = editableStatus
            }
          }
        }
      }
    }
  }
}

external interface MessdatenOverviewProps : Props {
  var project: ResolvedProject
  var currentConfiguration: QuoteConfiguration?
}
